(() => {
  const closeMenu = (menu) => {
    if (typeof menu.close === 'function') {
      menu.close();
    } else {
      const details = menu.querySelector('details');
      details?.removeAttribute('open');
      details?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    }
  };

  const syncBackdrop = () => {
    document.body.classList.toggle('pinned-mega-open', Boolean(document.querySelector('header-menu[data-pinned-mega-menu] details[open]')));
  };

  const initializeMenuTrigger = (menu) => {
    if (menu.dataset.pinnedInitialized === 'true') return;
    menu.dataset.pinnedInitialized = 'true';

    const details = menu.querySelector('details');
    const summary = details?.querySelector('summary');
    if (!details || !summary) return;

    let closeTimer;
    const canHover = () => window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
    const open = () => {
      if (!canHover()) return;
      window.clearTimeout(closeTimer);
      document.querySelectorAll('header-menu details[open]').forEach((item) => {
        if (item !== details) closeMenu(item.closest('header-menu'));
      });
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      syncBackdrop();
    };
    const scheduleClose = () => {
      if (!canHover()) return;
      closeTimer = window.setTimeout(() => {
        if (!menu.matches(':hover') && !menu.contains(document.activeElement)) closeMenu(menu);
        syncBackdrop();
      }, 140);
    };

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', scheduleClose);
    menu.addEventListener('focusin', open);
    details.addEventListener('toggle', syncBackdrop);
    summary.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu(menu);
        summary.focus();
        syncBackdrop();
      }
    });
  };

  if (!customElements.get('pinned-mega-tabs')) {
    customElements.define('pinned-mega-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.tabs = [...this.querySelectorAll('[data-pinned-mega-tab]')];
        this.panels = [...this.querySelectorAll('[data-pinned-mega-panel]')];

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('mouseenter', () => this.activate(tab));
          tab.addEventListener('focus', () => this.activate(tab));
          tab.addEventListener('click', () => this.activate(tab));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = index;
            if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = this.tabs.length - 1;
            this.tabs[nextIndex].focus();
          });
        });
      }

      activate(activeTab) {
        const handle = activeTab.dataset.pinnedMegaTab;
        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.pinnedMegaPanel !== handle;
        });
      }
    });
  }

  const initialize = (root = document) => {
    root.querySelectorAll('header-menu[data-pinned-mega-menu]').forEach(initializeMenuTrigger);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('click', () => window.requestAnimationFrame(syncBackdrop));
})();
